(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3813,9307,9921,1275],{

/***/ 91586:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores",
      function () {
        return __webpack_require__(7007);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2502:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(17256)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(19599);
var _requestIdleCallback = __webpack_require__(94242);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 7007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60107);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7494);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19599);
/* harmony import */ var components_common_Loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40897);





// TODO: Add description
var StoreKeepa = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2217), __webpack_require__.e(5399), __webpack_require__.e(8092), __webpack_require__.e(9819), __webpack_require__.e(3638), __webpack_require__.e(2718)]).then(__webpack_require__.bind(__webpack_require__, 82718));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82718)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    }
});
var Store = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: props.title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StoreKeepa, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Store);


/***/ }),

/***/ 79307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81663);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43903);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59416);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43493);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19599);
/* harmony import */ var utility_shimmer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34115);







var ImageKit = function(props) {
    var src = props.src, alt = props.alt, width = props.width, height = props.height, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "src",
        "alt",
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        blurDataURL: "data:image/svg+xml;base64,".concat((0,utility_shimmer__WEBPACK_IMPORTED_MODULE_5__/* .shimmer */ .f)(width, height, 12)),
        src: src || "",
        alt: alt,
        width: width,
        height: height
    }, !others.priority && {
        loading: "lazy"
    }, others));
};
/* harmony default export */ __webpack_exports__["default"] = (ImageKit);
ImageKit.defaultProps = {
    quality: 50,
    layout: "intrinsic",
    priority: false,
    src: "",
    alt: "keepa"
};
ImageKit.propTypes = {
    layout: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOf([
        "fill",
        "intrinsic",
        "responsive",
        "fixed"
    ]),
    priority: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired),
    src: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    loader: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    blurDataURL: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    objectFit: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};


/***/ }),

/***/ 40897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34427);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93359);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92021);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19599);
/* harmony import */ var assets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57730);
/* harmony import */ var hooks_useFindLocation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76035);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79307);









var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100vh",
            background: theme.palette.primary[800]
        },
        entekhabino: {
            background: theme.palette.background.light
        },
        animation: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            animation: "ripple 5s ease"
        },
        "@keyframes ripple": {
            "0%": {
                transform: "scale(.4)",
                opacity: 1
            },
            "25%": {
                transform: "scale(.8)",
                opacity: 0.5
            },
            "50%": {
                transform: "scale(1.2)",
                opacity: 0.5
            },
            "75%": {
                transform: "scale(1.6)",
                opacity: 0.5
            },
            "100%": {
                transform: "scale(2)",
                opacity: 0
            }
        }
    };
});
var LoadingElement = function() {
    var classes = useStyles();
    var isEntekhabinoPage = (0,hooks_useFindLocation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isEntekhabinoPage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, classes.entekhabino, isEntekhabinoPage)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            className: classes.animation,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                src: isEntekhabinoPage ? assets__WEBPACK_IMPORTED_MODULE_2__/* .EntekhabinoLogo */ .ffK : assets__WEBPACK_IMPORTED_MODULE_2__/* .KeepaLogoWhite */ .csh,
                quality: 10,
                priority: true,
                width: isEntekhabinoPage ? 280 : 160,
                height: isEntekhabinoPage ? 100 : 160
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingElement);


/***/ }),

/***/ 76035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83944);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

var useFindLocation = function() {
    var ref, ref1;
    var ref2 = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(), pathname = ref2.pathname, query = ref2.query;
    var isSearchPage = pathname.includes("/search");
    var isStoresPage = pathname.includes("/stores") && !(query === null || query === void 0 ? void 0 : (ref = query.all) === null || ref === void 0 ? void 0 : ref.length);
    var isStoreDetailsPage = pathname.includes("/stores") && !(query === null || query === void 0 ? void 0 : (ref1 = query.all) === null || ref1 === void 0 ? void 0 : ref1.length);
    var isEntekhabinoPage = pathname.includes("/entekhabino");
    var isEntekhabPage = pathname.includes("/entekhab");
    var isDigiKalaPage = pathname.includes("/digikala");
    var isRegistration = pathname.includes("/landing/medu");
    var isFara = pathname.includes("/landing/fara");
    return {
        isSearchPage: isSearchPage,
        isStoresPage: isStoresPage,
        isStoreDetailsPage: isStoreDetailsPage,
        isEntekhabinoPage: isEntekhabinoPage,
        isEntekhabPage: isEntekhabPage,
        isDigiKalaPage: isDigiKalaPage,
        isRegistration: isRegistration,
        isFara: isFara
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useFindLocation);


/***/ }),

/***/ 34115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ shimmer; }
/* harmony export */ });
var toBase64 = function(str) {
    return  false ? 0 : window.btoa(str);
};
var shimmer = function(w, h, b) {
    return toBase64('\n<svg width="'.concat(w, '" height="').concat(h, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n  <defs>\n    <linearGradient id="g">\n      <stop stop-color="#ddd" offset="20%" />\n      <stop stop-color="#eee" offset="50%" />\n      <stop stop-color="#ddd" offset="70%" />\n    </linearGradient>\n  </defs>\n  <rect width="').concat(w, '" height="').concat(h, '" fill="#ddd" rx="').concat(b, '" />\n  <rect id="r" width="').concat(w, '" height="').concat(h, '" fill="url(#g)" rx="').concat(b, '" />\n  <animate xlink:href="#r" attributeName="x" from="-').concat(w, '" to="').concat(w, '" dur="1s" repeatCount="indefinite"  />\n</svg>'));
};



/***/ }),

/***/ 7494:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(57484)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9416,7407,5366,7730,9774,2888,179], function() { return __webpack_exec__(91586); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);